import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ProductCard } from "./ProductCard";

const FILTERS = [
  { id: "todas", label: "Todas" },
  { id: "colgantes", label: "Colgantes" },
  { id: "mesa", label: "Mesa" },
  { id: "pie", label: "Pie" },
  { id: "pared", label: "Pared / Apliques" },
];

const SORTS = [
  { id: "destacados", label: "Destacados" },
  { id: "precio-asc", label: "Precio: menor a mayor" },
  { id: "precio-desc", label: "Precio: mayor a menor" },
  { id: "novedades", label: "Novedades" },
];

export const Catalog = ({ products, filter, onFilterChange, onQuickView, onAdd }) => {
  const [sort, setSort] = useState("destacados");

  const visible = useMemo(() => {
    let list = filter === "todas" ? [...products] : products.filter((p) => p.category === filter);
    if (sort === "precio-asc") list.sort((a, b) => a.price - b.price);
    else if (sort === "precio-desc") list.sort((a, b) => b.price - a.price);
    else if (sort === "novedades") list.reverse();
    return list;
  }, [products, filter, sort]);

  return (
    <section id="catalogo" data-testid="catalog-section" className="mx-auto max-w-7xl px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-12 flex flex-col gap-8 md:flex-row md:items-end md:justify-between"
      >
        <div>
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-amber-700/80 dark:text-amber-400/90">
            El catálogo
          </p>
          <h2 className="font-serif text-3xl font-light tracking-tight text-stone-900 dark:text-stone-50 sm:text-4xl lg:text-5xl">
            Luz que habita contigo
          </h2>
        </div>
        <select
          data-testid="catalog-sort-select"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="w-fit rounded-full border border-stone-200 bg-white px-5 py-2.5 text-sm text-stone-700 outline-none transition-colors focus:border-amber-500 dark:border-stone-700 dark:bg-stone-900 dark:text-stone-200"
        >
          {SORTS.map((s) => (
            <option key={s.id} value={s.id}>{s.label}</option>
          ))}
        </select>
      </motion.div>

      <div className="mb-12 flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button
            key={f.id}
            data-testid={`catalog-filter-${f.id}`}
            onClick={() => onFilterChange(f.id)}
            className={`rounded-full px-5 py-2 text-sm font-medium transition-all duration-300 ${
              filter === f.id
                ? "bg-stone-900 text-[#FDFBF7] dark:bg-stone-50 dark:text-stone-900"
                : "border border-stone-200 text-stone-600 hover:border-stone-400 hover:text-stone-900 dark:border-stone-700 dark:text-stone-300 dark:hover:border-stone-500 dark:hover:text-white"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <motion.div layout className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
        <AnimatePresence mode="popLayout">
          {visible.map((p) => (
            <ProductCard key={p.id} product={p} onQuickView={onQuickView} onAdd={onAdd} />
          ))}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};
